var _rect, _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChannelListEmptyState(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 258,
    viewBox: "0 0 258 258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 258,
    height: 258,
    rx: 129,
    fill: "#292836",
    fillOpacity: 0.06
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8_33033",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 258,
    height: 258
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1 129C-1 0 -1 0 128 0C257 0 257 0 257 129C257 200.245 199.245 258 128 258C56.7553 258 -1 200.245 -1 129Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8_33033)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_8_33033)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 243,
    width: 181,
    height: 66,
    rx: 7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.2188,
    cy: 276,
    rx: 19.0625,
    ry: 20,
    fill: "#C4C4CE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 243,
    width: 181,
    height: 66,
    rx: 7,
    stroke: "#EBEAEE",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 171,
    width: 181,
    height: 66,
    rx: 7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.1562,
    cy: 204,
    r: 20,
    fill: "#C4C4CE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.719,
    y: 188,
    width: 41.9375,
    height: 12,
    rx: 6,
    fill: "#C4C4CE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.719,
    y: 208,
    width: 76.25,
    height: 12,
    rx: 6,
    fill: "#EBEAEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 171,
    width: 181,
    height: 66,
    rx: 7,
    stroke: "#EBEAEE",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 99,
    width: 181,
    height: 66,
    rx: 7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.1562,
    cy: 132,
    r: 20,
    fill: "#C4C4CE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.719,
    y: 116,
    width: 41.9375,
    height: 12,
    rx: 6,
    fill: "#C4C4CE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.719,
    y: 136,
    width: 76.25,
    height: 12,
    rx: 6,
    fill: "#EBEAEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 99,
    width: 181,
    height: 66,
    rx: 7,
    stroke: "#EBEAEE",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 27,
    width: 181,
    height: 66,
    rx: 7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.1562,
    cy: 60,
    r: 20,
    fill: "#4F830F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.719,
    y: 44,
    width: 41.9375,
    height: 12,
    rx: 6,
    fill: "#4F830F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.719,
    y: 64,
    width: 76.25,
    height: 12,
    rx: 6,
    fill: "#4F830F14"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 27,
    width: 181,
    height: 66,
    rx: 7,
    stroke: "#EBEAEE",
    strokeWidth: 2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_8_33033",
    x: 13,
    y: 22,
    width: 232,
    height: 328,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_8_33033"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8_33033"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_8_33033"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8_33033",
    result: "effect2_dropShadow_8_33033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8_33033",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelListEmptyState);
export default __webpack_public_path__ + "static/media/channel-list-empty-state.49b2cc22.svg";
export { ForwardRef as ReactComponent };